import React, { Component } from 'react'

// import classes from './reportAppraisalByLevel.scss'
import { updateFilterOptions, extractFilterOptions, updateObject } from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
import Grid from '@material-ui/core/Grid'
import PageInfo from '../../../../components/PageInfo/PageInfo'
import { withTranslate } from 'react-redux-multilingual'

class ReportAppraisalByLevel extends Component {
  state = {
    filterModalOpen: false,
    filter: {},
    openPreview: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('levelGroup'),
          options: []
        },
        required: false
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        },
        required: false
      },
      format: {
        label: this.props.translate('format'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('format'),
          options: [
            { value: 'pdf', label: 'PDF' },
            { value: 'xlsx', label: 'Excel' }
          ]
        },
        required: true
      }
    },
    filterOptions: {
      companyFilterOptions: this.props.companyFilterOptions,
      formFilterOptions: this.props.formFilterOptions,
      levelGroupFilterOptions: this.props.levelGroupFilterOptions,
      orgFilterOptions: this.props.orgFilterOptions
    }
  }

  static getDerivedStateFromProps = (props, state) => {
    let updatedState = { ...state }
    if (props.companyFilterOptions !== updatedState.filterOptions.companyFilterOptions) {
      const companyFilter = updatedState.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' }
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          company_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          companyFilterOptions: props.companyFilterOptions
        }
      }
    }
    if (props.formFilterOptions !== updatedState.filterOptions.formFilterOptions) {
      const formFilter = updatedState.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { form_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          formFilterOptions: props.formFilterOptions
        }
      }
    }
    if (props.levelGroupFilterOptions !== updatedState.filterOptions.levelGroupFilterOptions) {
      const levelGroupFilter = updatedState.filterControls.level_group_id
      let updatedFilterItem = updateFilterOptions(
        props.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          level_group_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          levelGroupFilterOptions: props.levelGroupFilterOptions
        }
      }
    }
    if (props.orgFilterOptions !== updatedState.filterOptions.orgFilterOptions) {
      const orgFilter = updatedState.filterControls.org_id
      let updatedFilterItem = updateFilterOptions(
        props.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { org_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          orgFilterOptions: props.orgFilterOptions
        }
      }
    }
    return updatedState
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false,
      openPreview: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data
      let value = ''
      if (datakey === 'format') {
        value = { value: 'pdf', label: 'PDF' }
      }
      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: value }
      })
    })

    this.props.fetchCompanyOptions({ appraisal_type_id: 10 })
    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      openPreview: false,
      filter: []
    })
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    const updatedItem = { ...filterItem, value: filterValue }
    let updatedFilterControls = updateObject(this.state.filterControls, { [itemKey]: updatedItem })
    let filterOptions = extractFilterOptions(updatedFilterControls)
    filterOptions = { ...filterOptions, appraisal_type_id: 10 }

    if (itemKey === 'company_id') {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrganizationOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchOrganizationOptions(filterOptions)
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let filter = extractFilterOptions(this.state.filterControls)
    let par = {
      param_appraisal_type: 10,
      param_company: filter?.company_id,
      param_form: filter?.form_id,
      param_level_group: filter?.level_group_id,
      param_org: filter?.org_id
    }
    let parameters = {}
    Object.entries(par).map(form => {
      let [key, formAttrs] = form

      if (formAttrs !== undefined) {
        parameters = {
          ...parameters,
          [key]: formAttrs
        }
      }
      return form
    })

    let param = {
      parameters: parameters,
      format: filter.format,
      locale: localStorage.getItem('language')
    }
    this.props.reportAppraisalByLevel(param)
    this.setState({
      openPreview: true
    })
    this.closeFilterModal()
  }

  render() {
    let formLoading = <Spinner />
    if (!this.props.loading) {
      formLoading = <PleaseFilter />
    }
    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.filterLoading}
        />
        <Alert />
        <Card>
          <CardHeader
            title={
              <Grid container>
                <Grid item xs sm md>
                  <PageInfo pageTranslateKey={'reportAppraisalByLevel'} />
                </Grid>
                <Grid item xs sm md={4}>
                  <FilterBar buttonClicked={this.openFilterModal} />
                </Grid>
              </Grid>
            }></CardHeader>
          <CardBody>{formLoading}</CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    loading: state.reportAppraisalByLevel.loading,
    filterLoading: state.reportAppraisalByLevel.loadingStates,
    success: state.reportAppraisalByLevel.success,
    companyFilterOptions: state.reportAppraisalByLevel.company,
    formFilterOptions: state.reportAppraisalByLevel.form,
    levelGroupFilterOptions: state.reportAppraisalByLevel.levelGroup,
    orgFilterOptions: state.reportAppraisalByLevel.org,
    report: state.reportAppraisalByLevel.report
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchFilter: () => {
      dispatch(actions.fetchAppraisalTypeOptionsForAppraisal())
      // dispatch(actions.fetchCompanyOptionsForAppraisal())
      // dispatch(actions.fetchFormOptions())
      // dispatch(actions.fetchLevelGroupOptions())
      // dispatch(actions.fetchOrganizationOptions())
      // dispatch(actions.fetchPositionOptions())
      // dispatch(actions.fetchEmployeeOptions())
    },
    fetchCompanyOptions: filter => dispatch(actions.fetchCompanyOptionsForAppraisal(filter)),
    fetchFormOptions: filter => dispatch(actions.fetchFormOptionsForAppraisal(filter)),
    fetchOrganizationOptions: filter =>
      dispatch(actions.fetchOrganizationOptionsForAppraisal(filter)),
    fetchLevelGroupOptions: filter => dispatch(actions.fetchLevelGroupOptionsForAppraisal(filter)),
    reportAppraisalByLevel: filter => dispatch(actions.reportAppraisalByLevel(filter)),
    clearReportAppraisalByLevel: () => dispatch(actions.clearReportAppraisalByLevel())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ReportAppraisalByLevel))
